// src/store/customizationReducer.js
// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    isOpen: [], // for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true,
    navType: localStorage.getItem('navType') || 'light', //ESTE VALOR SE UTILIZA PARA DEFINIR EL MODO DE COLOR DE LA APLICACIÓN, PUEDE SER 'light' O 'dark', Y SE PASA A LA FUNCIÓN themePalette PARA CONFIGURAR LOS COLORES DE LA APLICACIÓN EN CONSECUENCIA.
    contrastLevel: localStorage.getItem('contrastLevel') || 'normal' // ESTE VALOR SE UTILIZA PARA DEFINIR EL NIVEL DE CONTRASTE DE LA APLICACIÓN, PUEDE SER 'normal' O 'high-contrast', Y SE PASA A LA FUNCIÓN themePalette PARA CONFIGURAR LOS COLORES DE LA APLICACIÓN EN CONSECUENCIA.
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };
        case actionTypes.SET_NAV_TYPE: //ESTE CASO SE UTILIZA PARA ACTUALIZAR EL TIPO DE NAVEGACIÓN (MODO DE COLOR) EN EL ESTADO DE LA APLICACIÓN, LO QUE PERMITE CAMBIAR ENTRE MODO CLARO Y OSCURO.
            return {
                ...state,
                navType: action.navType
            };
        case actionTypes.SET_CONTRAST_LEVEL: //ESTE CASO SE UTILIZA PARA ACTUALIZAR EL NIVEL DE CONTRASTE EN EL ESTADO DE LA APLICACIÓN, LO QUE PERMITE CAMBIAR ENTRE CONTRASTE NORMAL Y ALTO.
            return {
                ...state,
                contrastLevel: action.contrastLevel
            };
        default:
            return state;
    }
};

export default customizationReducer;
